// Obiectele pe care desenul NU le arată — desenate, ca să se vadă unde stau.
//
// Perechea vizuală a inventarului (`canonical.inventarDocument`). Panoul spune
// CÂTE și DE CE; asta spune UNDE. Fără al doilea, «2 rampe pe un planșeu
// inexistent» rămâne o propoziție pe care n-ai cum s-o verifici: exact rampele
// din afara subsolului au pornit toată discuția, iar ce lipsea era să le VEZI
// stând în afara conturului.
//
// NU E UN STRAT AL PLANULUI, deși are bifa lui. Un strat desenează ce spune
// documentul; ăsta desenează ce documentul spune ȘI desenul tace. De aia arată
// altfel decât orice altceva de pe pânză — linie întreruptă, hașură, culoare pe
// care planul n-o folosește nicăieri — și de aia nu e „încă un lucru desenat":
// ce se vede aici e o întrebare, nu o afirmație despre clădire.

import type { Fantoma } from "../canonical";
import { numeleMotivului } from "../canonical";
import { DECOR } from "./glyphs";

/** Chihlimbariul de „cineva trebuie să se uite la asta".
 *
 *  Nu roșu: roșul e verdictul de neconformitate al validatorului
 *  (`AnnotationLayer.COLOUR.neconform`), iar un obiect nedesenat nu e o normă
 *  încălcată — e o întrebare deschisă. Două lucruri diferite n-au voie să
 *  împartă culoarea pe același desen. */
const FANTOMA = "#b45309";
const HASURA = "fantoma-hasura";

/** Hașura, declarată o dată. Un `pattern` per fantomă ar fi însemnat, pe un
 *  document stricat, câteva sute de definiții identice. */
export function DefsFantome() {
  return (
    <defs>
      <pattern id={HASURA} width={6} height={6} patternUnits="userSpaceOnUse"
               patternTransform="rotate(45)">
        <line x1={0} y1={0} x2={0} y2={6} stroke={FANTOMA} strokeWidth={1.4}
              opacity={0.55} />
      </pattern>
    </defs>
  );
}

export default function Fantome({ fantome }: { fantome: Fantoma[] }) {
  if (!fantome.length) return null;
  return (
    <g style={DECOR}>
      <DefsFantome />
      {fantome.map((f) => (
        <polygon key={f.eid}
                 points={f.poly.map((p) => `${p[0]},${p[1]}`).join(" ")}
                 fill={`url(#${HASURA})`} stroke={FANTOMA} strokeWidth={1.4}
                 strokeDasharray="6 3" vectorEffect="non-scaling-stroke">
          {/* Titlul nativ, nu inspectorul: `Selection` indexează în familiile
              planului, iar o fantomă e prin definiție în afara lor. Un tip nou
              de selecție ar fi cerut și `describeSelection`, și contextul care
              duce fantomele până acolo — mai mult decât cere întrebarea «ce e
              chestia asta». Aici sunt cele patru lucruri după care se caută în
              JSON: tipul, funcțiunea, id-ul și motivul. */}
          <title>
            {`${f.type}${f.kind ? ` · ${f.kind}` : ""}\n${f.eid}\n`
             + `${numeleMotivului(f.motiv)}${f.storey ? ` · storey: ${f.storey}` : ""}`}
          </title>
        </polygon>
      ))}
    </g>
  );
}
